import i18n from "src/i18n";


export const getAdminSettingsNavLinks = () => [
  {
    id: 3,
    label: i18n.t("resource-management"),
    value: "resource-management",
    isEnabled: true,
  },
];
